var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99357 6.812C5.99357 5.22094 6.62571 3.69423 7.75068 2.56912C8.87565 1.44401 10.4024 0.812012 11.9936 0.812012C13.5847 0.812012 15.1113 1.44415 16.2364 2.56912C17.3615 3.69409 17.9935 5.22088 17.9935 6.812C17.9935 8.40311 17.3614 9.92976 16.2364 11.0549C15.1115 12.18 13.5847 12.812 11.9936 12.812C10.4025 12.8098 8.87798 12.1777 7.75288 11.0527C6.62788 9.92771 5.99574 8.40305 5.99357 6.812ZM22.0221 21.6962C21.9 21.1776 21.7307 20.6709 21.5164 20.1823C19.9885 16.6937 16.3404 14.5263 11.9936 14.5263C7.05867 14.5263 3.03878 17.3753 1.98773 21.6149C1.79702 22.3842 1.97166 23.1974 2.45917 23.822C2.94665 24.4456 3.69451 24.8109 4.48735 24.812H19.5043C20.2993 24.8141 21.0514 24.4488 21.5432 23.8231C22.0211 23.2252 22.1978 22.4408 22.0221 21.6962Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdown);
export default __webpack_public_path__ + "static/media/user-dropdown.2c0272da52a4647161e4ce9b66dfb55c.svg";
export { ForwardRef as ReactComponent };